import React, { useState } from "react";

import Popup from "../components/Popup";

import { Search } from "react-feather";
import { useForm } from "react-hook-form";

const PopupJoinCustomers = props => {
  const { trigger, setTrigger, customer, customers, setSelectedCustomerJoin, setPopupSelectedCustomerJoinChoice } = props;

  const { register, handleSubmit } = useForm();

  const submitJoin = data => {
    setSelectedCustomerJoin(data.customer);
    setPopupSelectedCustomerJoinChoice(true);
    setTrigger(false);
  };

  const [search, setSearch] = useState("");
  const filteredConsumers = search.length > 0
    ? customers?.filter(contact => contact.name.includes(search))
    : customers;

  return (
    <Popup title="Unificar clientes" trigger={trigger} setTrigger={setTrigger} width="400">

      <div className="chat__filter ">
        <span className="text-color d-block ml-20 mr-20 mt-10">
          Selecione o cliente que você deseja unir com o cliente: <span className="text-medium">{customer.name}</span>.
        </span>

        <form onSubmit={handleSubmit(submitJoin)}>
          <div className="x-p-20 mt-10">
            <div className="inner-search">
              <div className="search-icon">
                <Search size={24} />
              </div>

              <input className="search-input" type="text" placeholder="Pesquisar"
                onChange={e => setSearch(e.target.value)} value={search} />
            </div>
          </div>

          <ul className="filter__list ml-20 mr-20 mt-10 h-350 overflow-auto">
            {filteredConsumers.map(customerItem => {
              if (!!customer.usadao_id) { // se o cliente selecionado tiver conta no usadão
                if (!(!!customerItem.usadao_id)) {
                  if (customerItem.id !== customer.id) {
                    return (
                      <label key={customerItem.id} className="list__label">
                        <li className="list__item">
                          <input className="radio__btn" type="radio" name="customer" value={customerItem.id} {...register("customer")} />

                          <div className="list__item__image" style={{ backgroundImage: `url(${customerItem.profile_pic})`, flexShrink: 0 }} />

                          <p className="list__item__name text-limiter">
                            {customerItem.name}
                          </p>
                        </li>
                      </label>
                    );
                  }
                }
              } else { // se o cliente selecionado não tiver conta no usadão
                if (!!customerItem.usadao_id) {
                  if (customerItem.id !== customer.id) {
                    return (
                      <label key={customerItem.id} className="list__label">
                        <li className="list__item">
                          <input className="radio__btn" type="radio" name="customer" value={customerItem.id} {...register("customer")} />

                          <div className="list__item__image" style={{ backgroundImage: `url(${customerItem.profile_pic})`, flexShrink: 0 }} />

                          <p className="list__item__name text-limiter">
                            {customerItem.name}
                          </p>
                        </li>
                      </label>
                    );
                  }
                }
              }
            })}
          </ul>
          <div className="mb-20 ml-20 mr-20">
            <button className="btn btn-primary w-100" type="submit">
              Unir com o cliente selecionado
            </button>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default PopupJoinCustomers;